module.exports = __webpack_public_path__ + "img/Slide24.603950b6.png";